/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import "./HodViewOne.css";
import HodViewReq from "../../pages/hod_viewreq/HodViewReq";
import { Typography, Button, Input, Radio, Space, Select } from "antd";
import { FilePdfOutlined, FileWordOutlined } from "@ant-design/icons";
import CircularPercentage from "../../components/CircularPercentage";

export default function HodViewOne({ data }) {
    const { Title } = Typography;
    const { authData, backUrl } = useContext(AuthContext);
    const [mrfDetails, setMrfDetails] = useState(null);
    const [error, setError] = useState("");
    const [showData, setShowData] = useState(true);
    const [departments, setDepartments] = useState([]);
    const [designation, setDesignations] = useState([]);
    const [organizationNames, setOrganizationNames] = useState([]);
    const [workLocation, setWorkLocation] = useState([]);
    const [employee, setEmployee] = useState(null);
    const [showReportingTo, setShowReportingTo] = useState("");
    const [taken, setTaken] = useState(0);

    const fetchData = async () => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/manpowerrequisitions/${data}/`,
                {
                    headers: {
                        'Authorization': `Bearer ${authData.access}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            setMrfDetails(res.data);
        } catch (err) {
            console.error("Fetch error:", err);
            setError("Failed to fetch MRF data.");
        }
    };

    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/organisations/`, {
                headers: {
                    'Authorization': `Bearer ${authData.access}`,
                    'Content-Type': 'application/json',
                },
            });
            setOrganizationNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch organizations:", err);
        }
    };

    const fetchWorkLocation = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/worklocation/`);
            setWorkLocation(res.data.results);
        } catch (err) {
            console.error("Error fetching designations", err);
        }
    };

    const fetchDepartments = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/departments/`);
            setDepartments(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchDesignations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/designations/`);
            setDesignations(res.data.results);
        } catch (err) {
            console.error("Failed to fetch designations:", err);
        }
    };

    const fetchEmployees = async (id) => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/employees/${id}`, {
                headers: {
                    'Authorization': `Bearer ${authData.access}`,
                    'Content-Type': 'application/json',
                },
            });
            setEmployee(res.data);
            setShowReportingTo(() => res.data.user.first_name);
        } catch (err) {
            console.error("Failed to fetch organizations:", err);
        }
    };

    const fetchTaken = async () => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/candidates/?offerletter_status=ACCEPTED&requisition_id=${mrfDetails.id}`,
                {
                    headers: {
                        'Authorization': `Bearer ${authData.access}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            setTaken(res.data.count);
        } catch (err) {
            console.error("Failed to fetch taken count:", err);
        }
    };

    useEffect(() => {
        if (data) {
            fetchData();
            fetchDepartments();
            fetchDesignations();
            fetchOrganizations();
            fetchWorkLocation();
        }
    }, [data]);

    useEffect(() => {
        if (mrfDetails?.reporting_to) {
            fetchEmployees(mrfDetails.reporting_to);
        }
    }, [mrfDetails]);

    useEffect(() => {
        if (mrfDetails?.id) {
            fetchTaken();
        }
    }, [mrfDetails]);

    // Auto-refresh every 30 seconds
    useEffect(() => {
        if (data && authData?.access) {
            const interval = setInterval(() => {
                fetchData();
            }, 30000);
            return () => clearInterval(interval);
        }
    }, [data, authData]);

    const getOrganizationName = (id) => organizationNames.find(o => o.id === id)?.name || "N/A";
    const getDepartmentName = (id) => departments.find(dep => dep.id === id)?.name || id || "-";
    const getDesignationTitle = (id) => designation.find(des => des.id === id)?.name || id || "-";
    const handleClick = () => setShowData(false);

    // Helper function to get approval radio value
    const getApprovalValue = (approvalStatus) => {
        if (approvalStatus === true || approvalStatus === 1) return "approved";
        if (approvalStatus === false || approvalStatus === 0) return "rejected";
        return null;
    };

    return (
        <div className="view-container">
            {showData ? (
                <>
                    {error && <p className="text-danger">{error}</p>}
                    {!mrfDetails ? (
                        <p>Loading MRF Details...</p>
                    ) : (
                        <>
                            <button className="bread" onClick={handleClick}>
                                ← Back to List
                            </button>

                            <div className="d-flex justify-content-center align-items-center">
                                <section>
                                    <center><h5>Manpower Requisition Form</h5></center>
                                </section>
                                {mrfDetails.status === "Sanctioned" && (
                                    <section className="mx-5">
                                        <CircularPercentage vacancies={mrfDetails.no_of_vacancies} taken={taken} />
                                    </section>
                                )}
                            </div>

                            <div className="form container">
                                <div>
                                    <label>Organization </label>
                                    <input type="text" value={getOrganizationName(mrfDetails.organisation)} readOnly />
                                </div>

                                <div>
                                    <label>Department </label>
                                    <input type="text" value={getDepartmentName(mrfDetails.department)} readOnly />
                                </div>

                                <div>
                                    <label>Designation </label>
                                    <input type="text" value={getDesignationTitle(mrfDetails.designation)} readOnly />
                                </div>

                                <div>
                                    <label>Site/Location </label>
                                    <input type="text" value={mrfDetails.site_location || ""} readOnly />
                                </div>

                                <div>
                                    <label>Required By </label>
                                    <input type="text" name="required_by" value={mrfDetails.required_by || ""} readOnly />
                                </div>

                                <div>
                                    <label>No. of Vacancies </label>
                                    <input type="text" name="no_of_vacancies" value={mrfDetails.no_of_vacancies || ""} readOnly />
                                </div>
                            </div>

                            <center>
                                <div id="center-area">
                                    <div id="requisition-type">
                                        <label htmlFor="type">Requisition Type </label>
                                        <input type="text" value={mrfDetails.requisition_type || ""} readOnly />
                                    </div>
                                    {mrfDetails.hr_approved && (
                                        <div id="download-area">
                                            <Typography.Text>Download</Typography.Text>
                                            <Button
                                                type="link"
                                                icon={<FilePdfOutlined style={{ fontSize: '30px' }} />}
                                                onClick={async (e) => {
                                                    e.preventDefault();
                                                    try {
                                                        const response = await axios.get(
                                                            `${backUrl}/api/emp/mrf/${mrfDetails.mrf_number}/download/?type=1`,
                                                            { responseType: 'blob' }
                                                        );

                                                        const disposition = response.headers['content-disposition'];
                                                        let filename = 'download.pdf';
                                                        if (disposition && disposition.includes('filename=')) {
                                                            filename = disposition
                                                                .split('filename=')[1]
                                                                .replace(/['"]/g, '')
                                                                .trim();
                                                        }

                                                        const url = window.URL.createObjectURL(new Blob([response.data]));
                                                        const link = document.createElement('a');
                                                        link.href = url;
                                                        link.setAttribute('download', filename);
                                                        document.body.appendChild(link);
                                                        link.click();
                                                        document.body.removeChild(link);
                                                        window.URL.revokeObjectURL(url);
                                                    } catch (error) {
                                                        console.error('PDF download failed', error);
                                                    }
                                                }}
                                            />

                                            <Button
                                                type="link"
                                                icon={<FileWordOutlined style={{ fontSize: '30px' }} />}
                                                onClick={async (e) => {
                                                    e.preventDefault();
                                                    try {
                                                        const response = await axios.get(
                                                            `${backUrl}/api/emp/mrf/${mrfDetails.mrf_number}/download/?type=2`,
                                                            { responseType: 'blob' }
                                                        );

                                                        const disposition = response.headers['content-disposition'];
                                                        let filename = 'download.docx';
                                                        if (disposition && disposition.includes('filename=')) {
                                                            filename = disposition
                                                                .split('filename=')[1]
                                                                .replace(/['"]/g, '')
                                                                .trim();
                                                        }

                                                        const url = window.URL.createObjectURL(new Blob([response.data]));
                                                        const link = document.createElement('a');
                                                        link.href = url;
                                                        link.setAttribute('download', filename);
                                                        document.body.appendChild(link);
                                                        link.click();
                                                        document.body.removeChild(link);
                                                        window.URL.revokeObjectURL(url);
                                                    } catch (error) {
                                                        console.error('Word download failed', error);
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </center>

                            <hr />

                            <div className="form-2">
                                <div className="deployment-area">
                                    <h3>Deployment</h3>
                                    <label>Place Of Work </label>
                                    <input
                                        type="text"
                                        name="place_of_work"

                                        value={
                                            Array.isArray(mrfDetails.place_of_work)
                                                ? mrfDetails.place_of_work.join(", ")
                                                : ""
                                        }
                                        readOnly
                                    />

                                    <label>Job Description </label>
                                    <textarea name="job_description" value={mrfDetails.job_description || ""} readOnly />

                                    <a
                                        className="jd-anchor"
                                        href={mrfDetails.job_description_attachment}
                                        style={{
                                            background: 'transparent',
                                            color: 'black',
                                            textDecoration: 'none'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.color = 'black';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.color = 'black';
                                        }}
                                    >
                                        JD Attachment : View File
                                    </a>

                                    <hr />

                                    {mrfDetails.mrf_salary_from !== '' && (
                                        <>
                                            <h5>Salary Range</h5>
                                            <label>From </label>
                                            <input type="number" name="from" value={mrfDetails.mrf_salary_from || ""} readOnly />
                                            <label>To </label>
                                            <input type="number" name="to" value={mrfDetails.mrf_salary_to || ""} readOnly />
                                        </>
                                    )}
                                </div>

                                <div className="requirement-profile">
                                    <h3>Requirement Profile</h3>
                                    <label>Qualification </label>
                                    <input type="text" name="qualification" value={mrfDetails.qualification || ""} readOnly />

                                    <label>Experience </label>
                                    <input type="text" name="experience" value={mrfDetails.experience || ""} readOnly />

                                    <label>Skill Sets </label>
                                    <textarea name="skill_sets" value={mrfDetails.skill_sets || ""} readOnly />

                                    <label>Any Other Requirements </label>
                                    <textarea name="other_requirements" value={mrfDetails.other_requirements || ""} readOnly />

                                    <label>Justification </label>
                                    <textarea name="justification" value={mrfDetails.justification || ""} readOnly />
                                </div>
                            </div>

                            <hr />

                            {mrfDetails.requisition_type === 'Replacement' && (
                                <>
                                    <h3>If Replacement</h3>
                                    <div className="replacement-form">
                                        <div className="form-group">
                                            <label>Name of the Leaving Employee </label>
                                            <input type="text" name="name_of_leaving_employee" value={mrfDetails.name_of_leaving_employee || ""} readOnly />

                                            <label>Date of Leaving </label>
                                            <input type="text" name="date_of_leaving" value={mrfDetails.date_of_leaving || ""} readOnly />

                                            <label>Reason for Leaving </label>
                                            <textarea name="reason_for_leaving" value={mrfDetails.reason_for_leaving || ""} readOnly />
                                        </div>

                                        <div className="form-group">
                                            <label>Present Strength in the Category </label>
                                            <input type="text" name="present_dept_strength" value={mrfDetails.present_dept_strength || ""} readOnly />

                                            <label>Strength of the Function </label>
                                            <input type="text" name="strength_of_function" value={mrfDetails.strength_of_function || ""} readOnly />

                                            <label>Remarks </label>
                                            <textarea name="replacement_remarks" value={mrfDetails.replacement_remarks || ""} readOnly />
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* HOD/Manager Approval Status */}
                            {(mrfDetails.manager_approved === true || mrfDetails.manager_approved === false ||
                                mrfDetails.manager_approved === 1 || mrfDetails.manager_approved === 0) && (
                                    <center>
                                        <div className="p-4" id="approval-hod" style={{ textAlign: "center" }}>
                                            <Title level={4}>HOD Approval Status</Title>
                                            <br />

                                            <div className="approval-area">
                                                <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                                                    <Radio.Group
                                                        name="manager_approved"
                                                        value={getApprovalValue(mrfDetails.manager_approved)}

                                                    >
                                                        <Radio value="approved">Approved</Radio>
                                                        <Radio value="rejected">Rejected</Radio>
                                                    </Radio.Group>

                                                    <Input.TextArea
                                                        rows={4}
                                                        placeholder="Remarks"
                                                        value={mrfDetails.manager_remarks || ""}
                                                        readOnly
                                                        style={{ maxWidth: '500px' }}
                                                    />
                                                </Space>
                                            </div>
                                        </div>
                                    </center>
                                )}

                            {/* HR Approval Status */}
                            {(mrfDetails.hr_approved === true || mrfDetails.hr_approved === false ||
                                mrfDetails.hr_approved === 1 || mrfDetails.hr_approved === 0) && (
                                    <center>
                                        <div className="p-4" id="approval-hr" style={{ textAlign: "center" }}>
                                            <Title level={4}>HR Approval Status</Title>
                                            <br />

                                            <div className="approval-area">
                                                <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                                                    <Radio.Group
                                                        name="hr_approved"
                                                        value={getApprovalValue(mrfDetails.hr_approved)}

                                                    >
                                                        <Radio value="approved">Sanctioned</Radio>
                                                        <Radio value="rejected">Rejected</Radio>
                                                    </Radio.Group>

                                                    <Input.TextArea
                                                        rows={4}
                                                        placeholder="Remarks"
                                                        value={mrfDetails.hr_remarks || ""}
                                                        readOnly
                                                        style={{ maxWidth: '500px' }}
                                                    />
                                                </Space>
                                            </div>
                                            <br />

                                            {
                                                Boolean(mrfDetails.mrf_allocated_to) && String(mrfDetails.mrf_allocated_to) !== '0' && (
                                                    <Select
                                                        placeholder="Select HR"
                                                        style={{ width: 200 }}
                                                        allowClear={false}
                                                        value={mrfDetails.mrf_allocated_to}
                                                        disabled
                                                    >
                                                        <Select.Option value={mrfDetails.mrf_allocated_to}>
                                                            {mrfDetails.mrf_allocated_to_display}
                                                        </Select.Option>
                                                    </Select>
                                                )
                                            }
                                        </div>
                                    </center>
                                )}
                        </>
                    )}
                </>
            ) : (
                <HodViewReq />
            )}
        </div>
    );
}